<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import AiReviews from '~/components/modal-windows/AiReviews.vue'
import { useAiReviewsStore } from '~/store/ai-reviews'

const aiReviewsStore = useAiReviewsStore()

async function openAiReviewsModalWindow (): Promise<void> {
  await useModal({ component: AiReviews }).open()
}
</script>

<template>
  <article v-if="aiReviewsStore.aiSummaryText" class="rounded-xl bg-main-very-light-gray p-4 md:rounded-2xl md:p-5">
    <div class="mb-1 flex items-center justify-between md:mb-4">
      <div class="flex items-center">
        <SvgIcon class="!size-6" name="outlined/stars" />

        <h1
          class="
            !mb-0 ml-[6px] mr-[10px] text-xs font-normal leading-[1.33] text-main-green md:text-sm md:leading-[1.71]
          "
        >
          AI-саммари на&nbsp;основе отзывов покупателей
        </h1>
      </div>

      <SvgIcon
        class="text-main-green hover:cursor-pointer hover:text-main-blue"
        name="outlined/help-strong"
        @click="openAiReviewsModalWindow"
      />
    </div>

    <p class="!m-0 text-sm leading-[1.43] tracking-[-0.01em] md:text-base md:leading-6">
      {{ aiReviewsStore.aiSummaryText }}
    </p>
  </article>
</template>
